enum FarmerPlansRoutes {
  List = '/farmer-plans',
}

export default FarmerPlansRoutes
